/**
 * Central registry of TanStack Query keys.
 *
 * Keeping them here means an invalidation after a mutation can never miss a
 * cache entry because two files spelled the same key differently.
 */
export const queryKeys = {
  dashboard: () => ['dashboard'] as const,

  projects: {
    all: () => ['projects'] as const,
    list: (filters?: object) => ['projects', 'list', filters ?? {}] as const,
    detail: (projectId: string) => ['projects', 'detail', projectId] as const,
    phases: (projectId: string) => ['projects', projectId, 'phases'] as const,
    milestones: (projectId: string) => ['projects', projectId, 'milestones'] as const,
    team: (projectId: string) => ['projects', projectId, 'team'] as const,
    evidence: (projectId: string) => ['projects', projectId, 'evidence'] as const,
    pulse: (projectId: string) => ['projects', projectId, 'pulse'] as const,
  },

  activities: {
    all: () => ['activities'] as const,
    list: (filters?: object) => ['activities', 'list', filters ?? {}] as const,
    detail: (activityId: string) => ['activities', 'detail', activityId] as const,
  },

  updates: {
    byActivity: (activityId: string) => ['updates', 'activity', activityId] as const,
    detail: (updateId: string) => ['updates', 'detail', updateId] as const,
  },

  attention: {
    all: () => ['attention'] as const,
    list: (filters?: object) => ['attention', filters ?? {}] as const,
  },

  notifications: {
    list: () => ['notifications'] as const,
  },

  risks: {
    byProject: (projectId: string) => ['risks', 'project', projectId] as const,
  },

  issues: {
    byProject: (projectId: string) => ['issues', 'project', projectId] as const,
  },

  reports: {
    byProject: (projectId: string) => ['reports', 'project', projectId] as const,
    latest: (projectId: string) => ['reports', 'project', projectId, 'latest'] as const,
  },

  team: {
    members: () => ['team', 'members'] as const,
  },
} as const;
